$(document).ready(function () {
    $('[data-toggle="menu-clipper"]').menuClipper();
    $('[data-toggle="jumperPanel"]').jumperPanel();
    $('[data-toggle="ajaxPaginator"]').ajaxPaginator();
});